import { render, staticRenderFns } from "./ShowMyOrders.vue?vue&type=template&id=8cfa22e4&"
import script from "./ShowMyOrders.vue?vue&type=script&lang=js&"
export * from "./ShowMyOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports